import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

import { AuthService } from "../../auth/auth.service";
import { SnackBarService } from "../../core/snack-bar.service";
import { ValidationHelperService } from "../../core/validation-helper.service";

import { ChangePassword } from "./change-password.model";

@Component({
    template: require('./change-password-dialog.component.html'),
    styles: [require('./change-password-dialog.component.css')]
})
export class ChangePasswordDialogComponent implements OnInit {
    changePasswordForm: FormGroup;
    passwordChangeMandatory: boolean;
    loading: boolean;

    constructor(
        private authService: AuthService,
        private fb: FormBuilder,
        private snackBarService: SnackBarService,
        private validationHelperService: ValidationHelperService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ChangePasswordDialogComponent>) {

        this.changePasswordForm = this.fb.group({
            newPassword: ['', [Validators.required, Validators.maxLength(100)]],
            confirmPassword: ['', [Validators.required, Validators.maxLength(100)]],
        }, { validator: this.checkPasswords }); // see https://stackoverflow.com/a/43493648
    }

    ngOnInit() {
        this.passwordChangeMandatory = this.data.passwordChangeMandatory as boolean;
    }

    get newPasswordFC(): FormControl { return this.changePasswordForm.get("newPassword") as FormControl; }
    get confirmPasswordFC(): FormControl { return this.changePasswordForm.get("confirmPassword") as FormControl; }

    actionsDisabled(): boolean {
        return this.loading;
    }

    checkPasswords(group: FormGroup) {
        const newPassword = group.get("newPassword").value;
        const confirmPassword = group.get("confirmPassword").value;

        return newPassword === confirmPassword ? null : { notSame: true };
    }

    onSubmit(): void {
        if (this.changePasswordForm.invalid) {
            this.validationHelperService.markAllTouched(this.changePasswordForm);
            return;
        }

        this.loading = true;
        const dto: ChangePassword = this.changePasswordForm.value;

        this.authService.changePassword(dto)
            .then(() => {
                this.loading = false;
                this.snackBarService.openSnackBar("Password updated.");
                this.dialogRef.close();
            })
            .catch(err => {
                this.loading = false;
                this.snackBarService.openSnackBar(err);
            });
    }

    showPasswordMismatchError(): boolean {
        return this.confirmPasswordFC.touched && this.changePasswordForm.hasError("notSame");
    }

    showSpinner(): boolean {
        return this.loading;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/auth/change-password-dialog/change-password-dialog.component.ts